module.exports = __webpack_public_path__ + "static/media/cms-home-icon.4503bf21.svg";